import {
  AfterViewInit,
  ChangeDetectorRef,
  DestroyRef,
  Directive,
  ElementRef,
  OnInit,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FieldType, FieldTypeConfig, FormlyConfig } from '@ngx-formly/core';

@Directive()
export class DsFormlyFieldType extends FieldType<FieldTypeConfig> implements OnInit, AfterViewInit {
  formlyConfig = inject(FormlyConfig);
  changeDetectorRef = inject(ChangeDetectorRef);
  destroyRef = inject(DestroyRef);
  hostElement = inject<ElementRef<HTMLElement>>(ElementRef);

  ngOnInit() {
    this.formControl.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.changeDetectorRef.markForCheck());
  }

  ngAfterViewInit() {
    const key = this.field.key;
    if (key == null) {
      return;
    }

    const native = this.hostElement.nativeElement.querySelector('input');
    native?.setAttribute('data-id', String(key));
  }

  get error(): string | undefined {
    if (!this.showError) {
      return undefined;
    }

    return this.validationMessage() || 'Invalid value';
  }

  get helper(): string | undefined {
    const description = this.props.description;
    return typeof description === 'string' ? description : undefined;
  }

  validationMessage() {
    const errors = this.formControl.errors;

    if (!errors) {
      return undefined;
    }

    for (const error of Object.keys(errors)) {
      let message = this.formlyConfig.getValidatorMessage(error);
      const errorValue = errors[error] as { message?: string } | boolean;

      if (typeof errorValue === 'object' && errorValue?.message) {
        message = errorValue.message;
      }

      if (this.field.validation?.messages?.[error]) {
        message = this.field.validation.messages[error];
      }

      if (typeof message === 'function') {
        const result = message(errors[error], this.field);
        return typeof result === 'string' ? result : undefined;
      }

      return typeof message === 'string' ? message : undefined;
    }

    return undefined;
  }
}
